<app-header></app-header>
<main class="main-container">
    <router-outlet></router-outlet>
</main>
<app-footer></app-footer>
